import React from "react"

import Card from "./_Card"

function CareerCards({ decorators, pages, title }) {
  return (
    <section data-slice="CareerCards" className="md:pb-16 wrapper">
      <ul className="-mx-6 default-grid sm:-mx-fluidMargin md:mx-0 gap-y-0">
        {pages?.map((item, i) => (
          <Card {...item} key={`careerCard--${i}`} />
        ))}
      </ul>
    </section>
  )
}

export default CareerCards
